<template>
    <div v-if="marriageFavorableInfoData && marriageFavorableInfoData.infoMale && marriageFavorableInfoData.infoFemale"  class="marriage-result-energy-two dsp-flex pr">
        <div id="bgMale" class="marriage-energy-bg-box bg-male"></div>
        <div id="bgFemale" class="marriage-energy-bg-box bg-female"></div>
        <div class="marriage-energy-content-box">
            <!-- 头像部分 -->
            <div class="marriage-content-full dsp-flex">
                <!-- 男士头像 -->
                <div class="marriage-content-half text-center">
                    <div class="marriage-energy-avatar-box avatar-male">
                        <div class="avatar-content clearfix">
                            <div class="marriage-energy-avatar avatar-male"></div>
                            <span class="marriage-energy-nickname">{{ marriageFavorableInfoData.infoMale.name }}</span>
                        </div>
                        <div class="marriage-energy-fate"><span :class="'wd-'+marriageFavorableInfoData.infoMale.bz.wxEn">{{ marriageFavorableInfoData.infoMale.bz.text }}</span>命</div>
                    </div>
                </div>
                <!-- 女士头像 -->
                <div class="marriage-content-half text-center">
                    <div class="marriage-energy-avatar-box avatar-male">
                        <div class="avatar-content clearfix">
                            <div class="marriage-energy-avatar avatar-female"></div>
                            <span class="marriage-energy-nickname">{{ marriageFavorableInfoData.infoFemale.name }}</span>
                        </div>
                        <div class="marriage-energy-fate"><span :class="'wd-'+marriageFavorableInfoData.infoFemale.bz.wxEn">{{ marriageFavorableInfoData.infoFemale.bz.text }}</span>命</div>
                    </div>
                </div>
            </div>
            <div class="marriage-energy-sub-text pad-t-1">注意民间有用年柱纳音来测算是什么命的，以年来论命不严谨，一年出生的人那可太多了。</div>
            <div class="marriage-energy-content text-center">
                <div class="marriage-energy-title"><span>生日能量强弱</span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half text-center">
                    <div class="marriage-energy-strong">{{ marriageFavorableInfoData.infoMale.strong ? '身强' : '身弱' }}</div>
                </div>
                <div class="marriage-content-half text-center">
                    <div class="marriage-energy-strong">{{ marriageFavorableInfoData.infoFemale.strong ? '身强' : '身弱' }}</div>
                </div>
            </div>
            <div class="marriage-energy-sub-text">身强身弱并无绝对好坏，都有典型成功人士。身强的人精力更旺盛，抗击打能力更强。</div>
            <div class="marriage-energy-content text-center">
                <div class="marriage-energy-title"><span>生日五行能量大小分布</span></div>
            </div>
            <!-- 金 -->
            <div class="marriage-energy-bar-box marriage-content-full dsp-flex pad-t-1">
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-gold left">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoMale.gold.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoMale.gold.value + '%' }}</span></div>
                    </div>
                </div>
                <div class="marriage-energy-bar-box-mid text-center">
                    <div class="energy-bar-text2 item-gold">金</div>
                </div>
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-gold right">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoFemale.gold.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoFemale.gold.value + '%' }}</span></div>
                    </div>
                </div>
            </div>
            <!-- 木 -->
            <div class="marriage-energy-bar-box marriage-content-full dsp-flex">
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-wood left">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoMale.wood.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoMale.wood.value + '%' }}</span></div>
                    </div>
                </div>
                <div class="marriage-energy-bar-box-mid text-center">
                    <div class="energy-bar-text2 item-wood">木</div>
                </div>
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-wood right">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoFemale.wood.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoFemale.wood.value + '%' }}</span></div>
                    </div>
                </div>
            </div>
            <!-- 水 -->
            <div class="marriage-energy-bar-box marriage-content-full dsp-flex">
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-water left">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoMale.water.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoMale.water.value + '%' }}</span></div>
                    </div>
                </div>
                <div class="marriage-energy-bar-box-mid text-center">
                    <div class="energy-bar-text2 item-water">水</div>
                </div>
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-water right">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoFemale.water.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoFemale.water.value + '%' }}</span></div>
                    </div>
                </div>
            </div>
            <!-- 火 -->
            <div class="marriage-energy-bar-box marriage-content-full dsp-flex">
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-fire left">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoMale.fire.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoMale.fire.value + '%' }}</span></div>
                    </div>
                </div>
                <div class="marriage-energy-bar-box-mid text-center">
                    <div class="energy-bar-text2 item-fire">火</div>
                </div>
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-fire right">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoFemale.fire.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoFemale.fire.value + '%' }}</span></div>
                    </div>
                </div>
            </div>
            <!-- 土 -->
            <div class="marriage-energy-bar-box marriage-content-full dsp-flex">
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-soil left">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoMale.soil.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoMale.soil.value + '%' }}</span></div>
                    </div>
                </div>
                <div class="marriage-energy-bar-box-mid text-center">
                    <div class="energy-bar-text2 item-soil">土</div>
                </div>
                <div class="marriage-energy-bar-box-side">
                    <div class="energy-bar-item item-soil right">
                        <div class="energy-bar"><span class="energy-value" :style="'width: ' +marriageFavorableInfoData.infoFemale.soil.value+'%;'"></span><span class="energy-num">{{ marriageFavorableInfoData.infoFemale.soil.value + '%' }}</span></div>
                    </div>
                </div>
            </div>
            <div class="marriage-energy-content text-center">
                <div class="marriage-energy-title"><span>生日五行喜忌</span></div>
            </div>
            <div class="marriage-content-full text-center">
                <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>五行喜忌</span><span class="arrow-right"></span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half content-left">
                    <div class="marriage-energy-p">喜<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoMale.goodWx" :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span>，忌<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoMale.badWx" :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span></div>
                </div>
                <div class="marriage-content-half content-right">
                    <div class="marriage-energy-p">喜<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoFemale.goodWx" :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span>，忌<span :class="'wdd-'+gWx.wxEn" v-for="gWx in marriageFavorableInfoData.infoFemale.badWx" :key="gWx+Math.random(0,10)">{{ gWx.wxText }}</span></div>
                </div>
            </div>
            <div class="marriage-content-full text-center">
                <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>喜用颜色</span><span class="arrow-right"></span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half content-left">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoMale.goodColour.join('、') }}</div>
                </div>
                <div class="marriage-content-half content-right">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoFemale.goodColour.join('、') }}</div>
                </div>
            </div>
            <div class="marriage-content-full text-center">
                <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>忌用颜色</span><span class="arrow-right"></span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half content-left">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoMale.badColour.join('、') }}</div>
                </div>
                <div class="marriage-content-half content-right">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoFemale.badColour.join('、') }}</div>
                </div>
            </div>
            <div class="marriage-content-full text-center">
                <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>喜用生肖</span><span class="arrow-right"></span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half content-left">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoMale.goodAni.join('、') }}</div>
                </div>
                <div class="marriage-content-half content-right">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoFemale.goodAni.join('、') }}</div>
                </div>
            </div>
            <div class="marriage-content-full text-center">
                <div class="marriage-energy-sub-title"><span class="arrow-left"></span><span>易冲生肖</span><span class="arrow-right"></span></div>
            </div>
            <div class="marriage-content-full dsp-flex">
                <div class="marriage-content-half content-left">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoMale.badAni.join('、') }}</div>
                </div>
                <div class="marriage-content-half content-right">
                    <div class="marriage-energy-p">{{ marriageFavorableInfoData.infoFemale.badAni.join('、') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
export default {
    name: 'MarriageReportOneResult',
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    components: {  },
    computed: {
        marriageFavorableInfoData() {
            return this.$store.state.marriage.marriageFavorableInfoData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
        }
    },
    mounted() {
        let curPath = this.$router.history.current.path;
        let time = curPath.indexOf('share') == -1 ? 20 : 1500;
        setTimeout(() => {
            this.initDom();
        }, time);
    },
    methods: {
        initDom() {
            let bgBox1 = document.getElementById('bgMale');
            let bgBox2 = document.getElementById('bgFemale');
            let contentBox = document.getElementsByClassName('marriage-energy-content-box')[0];
            if(bgBox1) {
                bgBox1.style.height = contentBox ? contentBox.clientHeight+'px' : '';
            }
            if(bgBox2) {
                bgBox2.style.height = contentBox ? contentBox.clientHeight+'px' : '';
            }
        }
    }
}
</script>